const EmptySlot = ({ day, time, onClick }) => {
  return (
    <div
      className="absolute inset-0 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity duration-200 cursor-pointer"
      onClick={onClick}
    >
      <div className="bg-orange-500 text-white rounded-full w-7 h-7 flex items-center justify-center text-base font-medium hover:bg-orange-600 transition-colors shadow-sm">
        +
      </div>
    </div>
  );
};

export default EmptySlot;

